import {style} from 'typestyle'
import * as csstips from 'csstips'

export const HomePage = style({
    // paddingTop: 8,
    paddingBottom: 50,
    overflow: 'hidden',
    background: '#F7F7F7'
})

export const searchWrap = style({
    position: 'relative',
    background: '#fff',
    paddingTop: 10
    // $nest: {
    //     '&::after': {
    //         content: `" "`,
    //         position: `absolute`,
    //         left: `0`,
    //         height: 4,
    //         width: '100%',
    //         zIndex: 1,
    //         maxWidth: 480,
    //         background: '#fff'
    //     }
    // }
})



// WEBPACK FOOTER //
// ./src/views/Home/Home.style.ts